import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer class="wrapper footer-wrapper">
        <div class="wrapper footer-top-wrapper">
            <div class="container">
            <div class="row">
                <div class="col-md-6">
                <h5 class="footer-title"><span>Contact Us</span></h5>
                </div>
                <div class="col-md-6">
                    <a href='https://pmny.in/Cr3J7n0prfqU' > Pay Now </a> 
                </div>
            </div>
            <div class="row clearfix contact-row">
                <div class="col-sm-6">
                <ul class="list-unstyled info-ul info-ul-last">
                    <li class="flg-3"><span>Techno Web Solution</span>
                        <p>415, M.B Road, Phase - 3<br />	Kolkata: 700051<br />West Bengal, India</p>
                    </li>
                    <li><i class="fa fa-envelope"></i> <a href="mailto:sales@technowebsol.com">sales@technowebsol.com</a> </li>
                </ul>
                </div>
            </div>
            <div class="row clearfix links-row">
                <div class="col-md-2 col-sm-4">
                <h5>Navigation</h5>
                <ul class="list-unstyled">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about-us.html">About Us</Link></li>
                    <li><Link to="/services.html">Services</Link></li>
                    <li><Link to="/portfolio.html">Portfolio</Link></li>
                    <li><Link to="/ourteam.html">Our Team</Link></li>
                    <li><Link to="/contact-us.html">Contact us</Link></li>
                </ul>
                </div>
                <div class="col-md-2 col-sm-4">
                <h5>Our Services</h5>
                    <ul class="list-unstyled">
                        <li><Link to="/get-a-quote.html">Get a Quote</Link></li>
                        <li><Link to="/web-designing.html">Web Designing</Link></li>
                        <li><Link to="/web-development.html">Web Development</Link></li>
                        <li><Link to="/e-commerce-solutions.html">E-commerce Solutions</Link></li>
                        <li><Link to="/mobile-app-development.html">Mobile App Development</Link></li>
                        <li><Link to="/seo-service.html">SEO Service</Link></li>
                        <li><Link to="/testing-and-support.html">Testing and Support</Link></li>
                    </ul>
                </div>
                <div class="col-md-2 col-sm-4">
                <h5>Follow us on</h5>
                    <ul class="list-unstyled social-link">
                        <li><a href="https://www.facebook.com/technowebsolution" target="_blank"><i class="fa fa-facebook"></i><span>Facebook</span></a></li>
                        <li><a href="http://twitter.com/technowebsol" target="_blank"><i class="fa fa-twitter"></i><span>Twitter</span></a></li>
                        <li><a href="http://in.linkedin.com/in/technowebsol" target="_blank"><i class="fa fa-linkedin"></i><span>Linkedin</span></a></li>
                    </ul>
                </div>
            </div>
            </div>
        </div>
        <div class="wrapper footer-bottom-wrapper">
            <div class="container">
            <div class="row">
                <div class="col-lg-12">
                <div class="text-center">Techno Web Solution &copy; 2015 All Rights Reserved.</div>
                </div>
            </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer